import { OverlayModule } from '@angular/cdk/overlay';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, inject, InjectionToken, NgModule, ErrorHandler  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { BnNgIdleService } from 'bn-ng-idle';
//import { PopoverModule } from 'ngx-bootstrap/popover'
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { NgPipesModule } from 'ngx-pipes';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
// import { DialogModule } from 'primeng/dialog';
// import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';

import { DialerComponent } from './_core/components/dialer/dialer.component';
import { HeaderComponent } from './_core/components/header/header.component';
import { MenuComponent } from './_core/components/menu/menu.component';
import { ModalComponent } from './_core/components/modal/modal.component';
import { JwtInterceptor } from './_core/helper/jwt.interceptor';
import { LoadingInterceptor } from './_core/helper/loading.interceptor';
import { ExcelService } from './_core/services/excel.service';
import { SharedModule } from './_shared/shared.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ConfigService } from './config.services';
import { AnnouncedTransferComponent } from './pages/common/announced-transfer/announced-transfer.component';
import { CaseLockConfirmationComponent } from './pages/common/case-lock/case-lock.component';
import { ConfirmDialogComponent } from './pages/common/confirm-dialog/confirm-dialog.component';
import { EditAvatarComponent } from './pages/common/edit-avatar/edit-avatar.component';
import { FilterDialogComponent } from './pages/common/filter-dialog/filter-dialog.component';
import { MessageDialogComponent } from './pages/common/message-dialog/message-dialog.component';
import { ShowHideDialogComponent } from './pages/common/show-hide-dialog/show-hide-dialog.component';
import { ShowMessageComponent } from './pages/common/show-message/show-message.component';
import { TransferParticipantComponent } from './pages/common/transfer-participant/transfer-participant.component';
//import { StatusMenuComponent } from './pages/common/status-menu/status-menu.component';
import { TransferWindowComponent } from './pages/common/transfer-window/transfer-window.component';
import { ForgotpasswordComponent } from './pages/forgotpassword/forgotpassword.component';
import { LoginComponent } from './pages/login/login.component';
import { CaseDetailComponent } from './pages/queue/common/case-detail/case-detail.component';
import { CasesComponent } from './pages/queue/common/case-detail/cases/cases.component';
import { CreateCaseComponent } from './pages/queue/common/case-detail/cases/create-case/create-case.component';
import { UserSelectionComponent } from './pages/queue/common/case-detail/cases/user-selection/user-selection.component';
import { ClaimsComponent } from './pages/queue/common/case-detail/claims/claims.component';
import { CommunicationHistoryComponent } from './pages/queue/common/case-detail/communication-history/communication-history.component';
import { ComposeComponent } from './pages/queue/common/case-detail/compose/compose.component';
import { DispositionAndNotesComponent } from './pages/queue/common/case-detail/disposition-and-notes/disposition-and-notes.component';
import { DynamicTabViewComponent } from './pages/queue/common/case-detail/dynamic-tab-view/dynamic-tab-view.component';
import { MemberInformationComponent } from './pages/queue/common/case-detail/member-information/member-information.component';
import { ProviderInformationComponent } from './pages/queue/common/case-detail/provider-information/provider-information.component';
import { UserInformationComponent } from './pages/queue/common/case-detail/user-information/user-information.component';
import { TranslocoRootModule } from './transloco-root.module';
import { AddFindMemberComponent } from './pages/queue/common/case-detail/cases/add-find-member/add-find-member.component';
import { FileUploaderComponent } from './pages/common/file-uploader/file-uploader.component';
import { PhoneSettingsComponent } from './pages/common/phone-settings/phone-settings.component';
import { NotesHistoryComponent } from './pages/queue/common/case-detail/cases/notes-history/notes-history.component';
import { CaseAssignerComponent } from './pages/queue/common/case-detail/cases/case-assigner/case-assigner.component';
import { IdentifyUserComponent } from './pages/queue/common/case-detail/cases/identify-user/identify-user.component';
import { OutboundComponent } from './pages/queue/outbound/outbound.component';
import { AddRecordComponent } from './pages/queue/common/case-detail/cases/add-record/add-record.component';
import { OnvidaWrapperConfig, WindowsWrapper } from './app.config';
import { DisconnectCallComponent } from './pages/queue/common/case-detail/cases/disconnect-call/disconnect-call.component';
import { QueryParamInterceptor } from './_core/helper/RequestInterceptor';
import { CookieService } from 'ngx-cookie-service';
import { SwitchClientComponent } from './_core/components/switch-client/switch-client.component'
import { ReviewVoicemailComponent } from './pages/review-voicemail/review-voicemail.component';
import { TestCptComponent } from './pages/queue/common/case-detail/cases/test-cpt/test-cpt.component';
import { SessionTimeoutConfirmationComponent } from './pages/common/session-timeout/session-timeout.component';
import { CalendarWithTimezoneComponent } from './pages/common/calendar-with-timezone/calendar-with-timezone.component';
import { CleanResponseInterceptor } from './_core/helper/clean-response.interceptor';
import { errorLoggingInterceptor } from './_core/helper/error-logging.interceptor';
import { ConsoleModule } from './pages/console/console.module'
import { SelectAgentComponent } from './pages/console/voicemails/select-agent/select-agent.component';

import { AiNoteTemplateComponent } from './pages/queue/common/case-detail/cases/ai-note-template/ai-note-template.component';
import { ChatbotComponent } from './pages/common/chatbot/chatbot.component';
import { AddDocumentComponent } from './pages/console/knowledge-docs/add-document/add-document.component';
import { FilePreviewComponent } from './pages/console/knowledge-docs/file-preview/file-preview.component';
//import { ComposeEmailComponent } from './Common/compose-email/compose-email.component';
import { GlobalErrorHandler } from './_core/helper/global-error-handler';
const Wrapper: OnvidaWrapperConfig = {
    OnvidaWrapper: null,
    IsWrapper: false
}
export function getBaseHref(platformLocation: PlatformLocation): string {
    const val = platformLocation.getBaseHrefFromDOM();
    return val == '/' ? '.' : val;
}
export function initializeApp(configService: ConfigService) { 
    return () =>
        configService
            .loadConfig()
            .toPromise()
            .then(config => {
                configService.setConfig(config);
            });
} 
export function initializeWrapper(configService: ConfigService) { 
    return () =>
        configService
            .loadWrapper().toPromise().then(config => {
                Wrapper.OnvidaWrapper = config;
                Wrapper.IsWrapper = (config == null ? false : true);
                return config;
            });
}
@NgModule({
    declarations: [
        //ComposeEmailComponent,
        AppComponent,
        LoginComponent,
        ForgotpasswordComponent,
        CaseDetailComponent,
        CommunicationHistoryComponent,
        ComposeComponent,
        UserInformationComponent,
        CasesComponent,
        MemberInformationComponent,
        DispositionAndNotesComponent,
        ModalComponent,
        HeaderComponent,
        MenuComponent,
        FilterDialogComponent,
        ShowHideDialogComponent,
        ShowMessageComponent,
        DialerComponent,
        CasesComponent,
        CreateCaseComponent,
        UserSelectionComponent,
        TransferWindowComponent,
        TransferParticipantComponent,
        AnnouncedTransferComponent,
        EditAvatarComponent,
        ConfirmDialogComponent,
        DynamicTabViewComponent,
        MessageDialogComponent,
        ProviderInformationComponent,
        ClaimsComponent,
        CaseLockConfirmationComponent,
        AddFindMemberComponent,
        SelectAgentComponent,
        FileUploaderComponent,
        PhoneSettingsComponent,
        IdentifyUserComponent,
        NotesHistoryComponent,
        CaseAssignerComponent,
        AddRecordComponent,
        DisconnectCallComponent,
        SwitchClientComponent,
        ReviewVoicemailComponent,
        TestCptComponent,
        SessionTimeoutConfirmationComponent,
        CalendarWithTimezoneComponent,
        AiNoteTemplateComponent,
        ChatbotComponent,
        AddDocumentComponent,
        FilePreviewComponent
    ],
    exports: [DialerComponent, DialogModule, FileUploadModule],
    providers: [
        CookieService,
        BsModalService,
        ExcelService,
        HeaderComponent,
        OutboundComponent,
        BnNgIdleService,
        {
            provide: APP_BASE_HREF,
            useFactory: getBaseHref,
            deps: [PlatformLocation],
        },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: QueryParamInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
        {
            provide: TINYMCE_SCRIPT_SRC,
            useFactory: (baseHref: string) => `${baseHref}/tinymce/tinymce.min.js`,
            deps: [APP_BASE_HREF],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [ConfigService],
            multi: true,
        },
        { 
            provide: APP_INITIALIZER,
            useFactory: initializeWrapper,
            deps: [ConfigService],
            multi: true,
        }, 
        {
            provide: WindowsWrapper, useValue: Wrapper 
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CleanResponseInterceptor,
            multi: true
        },
        {   provide: HTTP_INTERCEPTORS, 
            useClass: errorLoggingInterceptor, 
            multi: true 
        },
        {   provide: ErrorHandler, 
            useClass: GlobalErrorHandler
        },
        // { provide: TINYMCE_SCRIPT_SRC, useValue: `${getBaseHref}/assets/tinymce/tinymce.min.js` },// () => inject(ConfigService).getWrapperConfig2(),
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        EditorModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule,
        AccordionModule.forRoot(),
        TranslocoRootModule,
        PaginatorModule,
        CalendarModule,
        SharedModule,
        DialogModule,
        ButtonModule,
        OverlayPanelModule,
        OverlayModule,
        TabViewModule,
        FileUploadModule,
        PanelModule,
        NgPipesModule,
        TableModule,
        ConsoleModule
    ],
})
export class AppModule { }
